import { render, staticRenderFns } from "./MaterialSnackbar.vue?vue&type=template&id=0f8cd242"
import script from "./MaterialSnackbar.vue?vue&type=script&lang=js"
export * from "./MaterialSnackbar.vue?vue&type=script&lang=js"
import style0 from "./MaterialSnackbar.vue?vue&type=style&index=0&id=0f8cd242&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports